// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contenedor-general {
  padding: 24px 32px;
}

.superior {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  font-family: Roboto, Segoe UI, wf_segoe-ui_normal, helvetica, arial, sans-serif;
  margin-bottom: 5px;
}

.botones mat-icon {
  cursor: pointer;
  padding-left: 2px;
}

.inputNuevo {
  border-bottom: 2px solid #cecece;
  width: 100%;
}

.slideAdministrar {
  margin-bottom: 25px;
  font-weight: 500;
}

.mat {
  width: 100%;
  margin-bottom: 15px;
}

.matInput {
  width: 100%;
}

.inputBusqueda {
  border-bottom: 2px solid #5b7f30;
}

.tablaInstalaciones {
  border: 1px solid #cecece;
}

@media screen and (max-width: 990px) {
  .superior h1 {
    font-size: 15px !important;
  }
}
.ocultar {
  display: none !important;
}

::ng-deep .mat-sort-header-button {
  width: 100% !important;
}

.mat ::ng-deep .mat-form-field-wrapper {
  padding-bottom: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/dialogs/perfil-usario/perfil-usario.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,+EAAA;EACA,kBAAA;AACJ;;AAEA;EACI,eAAA;EACA,iBAAA;AACJ;;AAEA;EACI,gCAAA;EACA,WAAA;AACJ;;AAEA;EACI,mBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,WAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,gCAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI;IACI,0BAAA;EACN;AACF;AAEA;EACI,wBAAA;AAAJ;;AAGA;EACI,sBAAA;AAAJ;;AAIA;EACI,8BAAA;AADJ","sourcesContent":[".contenedor-general {\r\n    padding: 24px 32px;\r\n}\r\n\r\n.superior {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-end;\r\n    font-family: Roboto, Segoe UI, wf_segoe-ui_normal, helvetica, arial, sans-serif;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.botones mat-icon {\r\n    cursor: pointer;\r\n    padding-left: 2px;\r\n}\r\n\r\n.inputNuevo {\r\n    border-bottom: 2px solid #cecece;\r\n    width: 100%;\r\n}\r\n\r\n.slideAdministrar {\r\n    margin-bottom: 25px;\r\n    font-weight: 500;\r\n}\r\n\r\n.mat {\r\n    width: 100%;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.matInput {\r\n    width: 100%;\r\n}\r\n\r\n.inputBusqueda {\r\n    border-bottom: 2px solid #5b7f30;\r\n}\r\n\r\n.tablaInstalaciones {\r\n    border: 1px solid #cecece;\r\n}\r\n\r\n@media screen and (max-width:990px) {\r\n    .superior h1 {\r\n        font-size: 15px !important;\r\n    }\r\n}\r\n\r\n.ocultar {\r\n    display: none !important;\r\n}\r\n\r\n::ng-deep .mat-sort-header-button {\r\n    width: 100% !important;\r\n}\r\n\r\n\r\n.mat ::ng-deep .mat-form-field-wrapper {\r\n    padding-bottom: 0px !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
